import { Router } from '@angular/router';
import { API_CALL_ERROR } from './../../../store/action';
import { PreloaderService } from './../../../common/services/preloader/preloader.service';
import { USER_COMP } from './../user.const';
import { COLLECTION_COMP } from '../../collection/collection.const';
import {PRODUCT_COMP, PRODUCT_EDIT_TEMPORARY_PRICE_COMP} from '../../product/product.const';
import { AppInjector } from './../../../app-injector';
import {
  FETCH_ALL_USER_REQUESTED,
  FETCH_ALL_USER_SUCCEEDED,
  DELETE_USER_REQUESTED,
  DELETE_USER_SUCCEEDED,
  FILTER_USERS_REQUESTED,
  FILTER_USERS_SUCCEEDED,
  FILTER_USERS_PROCESSING,
  IMPERSONATE_SUCCEEDED, IMPERSONATE_STARTED, IMPERSONATE_COMPLETED
} from './list.actions';
import { takeEvery, put } from 'redux-saga/effects';
import { ApiService } from '../../../api/api.service';
import * as _ from 'lodash';
import * as Cookies from "js-cookie";
import {environment} from "../../../../environments/environment";

function* getUsers(action) {
  try {
    AppInjector.get(PreloaderService).show();
    const results = yield AppInjector.get(ApiService)
      .user.get(action.data)
      .toPromise();

    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case USER_COMP:
          yield put({
            type: FETCH_ALL_USER_SUCCEEDED,
            data: results,
            com: USER_COMP
          });
          break;
        case COLLECTION_COMP:
          yield put({
            type: FETCH_ALL_USER_SUCCEEDED,
            data: results,
            com: COLLECTION_COMP
          });
          break;
        case PRODUCT_COMP:
          yield put({
            type: FILTER_USERS_SUCCEEDED,
            data: results,
            com: PRODUCT_COMP
          });
          break;
        default:
          break;
      }
    } else {
    }
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllUserRequest() {
  yield takeEvery(FETCH_ALL_USER_REQUESTED, getUsers);
}

function* deleteUser(action) {
  try {
    AppInjector.get(PreloaderService).show();
    const result = yield AppInjector.get(ApiService)
      .user.delete(action.data)
      .toPromise();

    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case USER_COMP:
          yield put({
            type: DELETE_USER_SUCCEEDED,
            data: result,
            com: action.com
          });
          break;

        default:
          break;
      }
    } else {
    }
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDeleteUserRequest() {
  yield takeEvery(DELETE_USER_REQUESTED, deleteUser);
}

function* reloadUsers(action) {
  try {
    AppInjector.get(PreloaderService).show();
    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case USER_COMP:
          AppInjector.get(Router).navigate(['/user']);
          break;

        default:
          break;
      }
    }
  } catch (e) {
    AppInjector.get(PreloaderService).show();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDeleteUserSuccess() {
  yield takeEvery(DELETE_USER_SUCCEEDED, reloadUsers);
}

function* filterUsers(action) {
  try {
    AppInjector.get(PreloaderService).show();
    yield put({ type: FILTER_USERS_PROCESSING });
    const encodedSearch = action.data.search ? encodeURIComponent(action.data.search) : null;
    const results = yield AppInjector.get(ApiService)
      .user.get(action.data.pagination, action.data.sort, action.data.filter, encodedSearch)
      .toPromise();

    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case USER_COMP:
          yield put({
            type: FILTER_USERS_SUCCEEDED,
            data: results,
            com: USER_COMP
          });
          break;
        case COLLECTION_COMP:
          yield put({
            type: FILTER_USERS_SUCCEEDED,
            data: results,
            com: COLLECTION_COMP
          });
          break;
        case PRODUCT_COMP:
          yield put({
            type: FILTER_USERS_SUCCEEDED,
            data: results,
            com: PRODUCT_COMP
          });
          break;
        case PRODUCT_EDIT_TEMPORARY_PRICE_COMP:
          yield put({
            type: FILTER_USERS_SUCCEEDED,
            data: results,
            com: PRODUCT_EDIT_TEMPORARY_PRICE_COMP
          });
          break;
        default:
          break;
      }
    } else {
    }
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFilterUsersRequest() {
  yield takeEvery(FILTER_USERS_REQUESTED, filterUsers);
}

function* impersonate(action) {
  try {
    const api = AppInjector.get(ApiService);
    let result = yield api.auth.impersonate(action.data).toPromise();
    Cookies.set('auth_token', result['data'].access_token, { domain: environment.domainName });
    yield put({ type: IMPERSONATE_SUCCEEDED, data: action.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}
function* watchImpersonateRequest() {
  yield takeEvery(IMPERSONATE_STARTED, impersonate);
}

function* completeImpersonate() {
  try {
    Cookies.remove('auth_token', { domain: environment.domainName });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}
function* watchImpersonateCompleteRequest() {
  yield takeEvery(IMPERSONATE_COMPLETED, completeImpersonate);
}

export default [watchFetchAllUserRequest, watchDeleteUserRequest, watchDeleteUserSuccess, watchFilterUsersRequest, watchImpersonateRequest, watchImpersonateCompleteRequest];
